import { render, staticRenderFns } from "./hls.vue?vue&type=template&id=25a8fa9c&scoped=true&"
import script from "./hls.vue?vue&type=script&lang=js&"
export * from "./hls.vue?vue&type=script&lang=js&"
import style0 from "./hls.vue?vue&type=style&index=0&id=25a8fa9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a8fa9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
